import { batch } from "@preact/signals-react"
import { FORMAT_DATE_BACK, formatDate, getPreviousDate, isEmpty } from "@ui-seeker/utils"

import { DATE_PERIODS } from "@constants"
import { commonFiltersValue } from "@signals"
import { evolutionChartCurrentPeriod, evolutionDataFilters, marketplacesLBBEndDate } from "../../@signals"


export default function useMarketplacesLostBuyBoxShowEvolution(productID, skuID, siteID) {
    const newFilters = commonFiltersValue.peek()

	const handleClickShowEvolution = () => batch(() => {
        marketplacesLBBEndDate.value = newFilters.endDate
        let startDate = formatDate(getPreviousDate({days: 6}, marketplacesLBBEndDate.value), { format: FORMAT_DATE_BACK, receivedFormat: "%Y-%m-%dT%H:%M:%S.%LZ" })

        evolutionChartCurrentPeriod.value = DATE_PERIODS.LAST_7_DAYS

        evolutionDataFilters.value = {
            ...commonFiltersValue.peek(),
            startDate: startDate,
            endDate: marketplacesLBBEndDate.value,
			productID: productID,
			sku: [skuID],
			retailer: [siteID]
        }
	})
   
	return {
        isOpenEvolutionChart: !isEmpty(evolutionDataFilters.value) && evolutionDataFilters.value['productID'] === productID,
		handleClickShowEvolution
	}
}